"use client"

import { ProjectType } from "./ProjectConfigurator"
import { MultiSelectCard } from "./MultiSelectCard"
import { Button } from "@/components/ui/button"

interface ProjectTypeSelectorProps {
  selectedTypes: ProjectType[]
  onChange: (types: ProjectType[]) => void
  onNext: () => void
}

const projectTypes = [
  {
    id: "website" as ProjectType,
    title: "Website",
    description: "New site, redesign, or optimization",
  },
  {
    id: "app" as ProjectType,
    title: "App",
    description: "Custom web apps and applications",
  },
  {
    id: "tool" as ProjectType,
    title: "Tool",
    description: "Internal tools and dashboards",
  },
  {
    id: "design" as ProjectType,
    title: "Design Work",
    description: "Brand, identity, and visual systems",
  },
  {
    id: "integrations" as ProjectType,
    title: "Integrations",
    description: "Systems, automation, and workflows",
  },
  {
    id: "consulting" as ProjectType,
    title: "Business Consulting",
    description: "Strategic systems architecture and guidance",
  },
  {
    id: "unknown" as ProjectType,
    title: "I Don't Know",
    description: "Not sure what you need? Let's figure it out",
  },
]

export function ProjectTypeSelector({
  selectedTypes,
  onChange,
  onNext,
}: ProjectTypeSelectorProps) {
  const handleToggle = (type: ProjectType) => {
    if (selectedTypes.includes(type)) {
      onChange(selectedTypes.filter((t) => t !== type))
    } else {
      onChange([...selectedTypes, type])
    }
  }

  return (
    <div className="space-y-8">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {projectTypes.map((type) => (
          <MultiSelectCard
            key={type.id}
            title={type.title}
            description={type.description}
            selected={selectedTypes.includes(type.id)}
            onClick={() => handleToggle(type.id)}
          />
        ))}
      </div>

      <div className="flex justify-end pt-4">
        <Button
          onClick={onNext}
          disabled={selectedTypes.length === 0}
          className="rounded-full bg-tk-teal px-8 py-2 text-sm font-semibold text-tk-linen hover:bg-tk-teal/90 font-ui disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Continue →
        </Button>
      </div>
    </div>
  )
}

